import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import S3FileUpload from "react-s3";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function HomePage(props) {
  const [isEmpty, setIsEmpty] = useState(false);
  const [clients, setClients] = useState([]);
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [eventIcons, setEventIcons] = useState([
    {
      image: null,
      value: "",
      title: "",
      description: "",
    },
  ]);
  const [wcEvents, setWcEvents] = useState([
    {
      image: null,
      title: "",
      description: "",
    },
  ]);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const getDashboardDetails = () => {
    setIsLoading(true);
    apiReq(url.GET_DASHBOARD_DETAILS, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    });
  };

  const user = useSelector((state) => state.User);
  const allFields = watch();

  // AWS Config
  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    // dirName: "downloads",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("user", props);

  // Todo: Clients
  // HandleImageUpload
  const uploadClientImage = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, { ...config, dirName: "clients" })
      .then((data) => {
        setClients([
          ...clients,
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`,
        ]);
      })
      .catch((err) => console.log(err));
  };

  // Todo: handleRemoveClient
  const handleRemoveClient = (index) => {
    const newClients = clients.filter((_, i) => i !== index);
    setClients(newClients);
  };

  // Todo: Events box
  const handleEventIconChange = (e, index) => {
    const { name, value } = e.target;
    const newEventIcons = [...eventIcons];
    newEventIcons[index][name] = value;
    setEventIcons(newEventIcons);
  };

  const uploadIconImage = (event, index) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, { ...config, dirName: "icons" })
      .then((data) => {
        const newAddresses = [...eventIcons];
        newAddresses[index][
          "image"
        ] = `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`;
        setEventIcons(newAddresses);
      })
      .catch((err) => console.log(err));
  };

  // Todo: Add new options
  const addEventIcon = () => {
    setEventIcons([
      ...eventIcons,
      {
        image: null,
        value: "",
        title: "",
        description: "",
      },
    ]);
  };

  // Todo: delete icon box
  const deleteEventIcon = (index) => {
    const newEventIcons = [...eventIcons];
    newEventIcons.splice(index, 1);
    setEventIcons(newEventIcons);
  };

  // Todo: uploadWhImage
  const uploadWhImage = (event, index) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, { ...config, dirName: "wcicons" })
      .then((data) => {
        const newWcEvents = [...wcEvents];
        newWcEvents[index][
          "image"
        ] = `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`;
        setWcEvents(newWcEvents);
      })
      .catch((err) => console.log(err));
  };

  // Todo: deleteWcEvent
  const deleteWcEvent = (index) => {
    const newWcEvents = [...wcEvents];
    newWcEvents.splice(index, 1);
    setWcEvents(newWcEvents);
  };

  // Todo: handleWcEventChange
  const handleWcEventChange = (e, index) => {
    const { name, value } = e.target;
    const newWcEvents = [...wcEvents];
    newWcEvents[index][name] = value;
    setWcEvents(newWcEvents);
  };

  // Todo: addWcEvent
  const addWcEvent = () => {
    setWcEvents([
      ...wcEvents,
      {
        image: null,
        title: "",
        description: "",
      },
    ]);
  };

  console.log("eventIcons", eventIcons);

  // get faqs
  const getHomePageDetails = () => {
    setIsLoading(true);
    apiReq(url.GET_HOMEPAGE, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("intro_title", res.data.intro_title);
          setValue("intro_description", res.data.intro_description);
          setValue("intro_video", res.data.intro_video);
          setValue("about_title", res.data.about_title);
          setValue("whyChoose_title", res.data.whyChoose_title);
          setValue("whyChoose_description", res.data.whyChoose_description);
          setValue("social_news_title", res.data.social_news_title);
          setValue("social_news_description", res.data.social_news_description);
          setValue("events_title", res.data.events_title);
          setValue("events_description", res.data.events_description);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);
          setValue("intro_button", res.data.intro_button);
          setValue("intro_button_link", res.data.intro_button_link);
          setValue("whyChoose_cta_title", res.data.whyChoose_cta_title);
          setValue("whyChoose_cta_link", res.data.whyChoose_cta_link);
          setValue("events_cta_title", res.data.events_cta_title);
          setValue("events_cta_link", res.data.events_cta_link);
          setValue("news_cta_title", res.data.news_cta_title);
          setValue("news_cta_link", res.data.news_cta_link);
          setClients(res.data.clients);
          setEventIcons(res.data.about_icons);
          setImage(res.data.intro_image);
          setWcEvents(res.data.whyChoose_events);
          //   setContent(res.data.content);
          console.log("res.data", res.data);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsEmpty(true);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getHomePageDetails();
    getDashboardDetails();
  }, []);

  // Todo: Create privacy page first time
  const createHomePage = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_HOMEPAGE,
        {
          intro_title: data.intro_title,
          intro_description: data.intro_description,
          intro_video: data.intro_video,
          clients: clients,
          about_title: data.about_title,
          about_icons: eventIcons,
          whyChoose_title: data.whyChoose_title,
          whyChoose_description: data.whyChoose_description,
          whyChoose_events: wcEvents,
          whyChoose_cta_title: data.whyChoose_cta_title,
          whyChoose_cta_link: data.whyChoose_cta_link,
          events_title: data.events_title,
          events_description: data.events_description,
          events_cta_title: data.events_cta_title,
          events_cta_link: data.events_cta_link,
          social_news_title: data.social_news_title,
          social_news_description: data.social_news_description,
          news_cta_title: data.news_cta_title,
          news_cta_link: data.news_cta_link,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
          intro_button: data.intro_button,
          intro_button_link: data.intro_button_link,
          intro_image: image,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_HOMEPAGE,
        {
          intro_title: data.intro_title,
          intro_description: data.intro_description,
          intro_video: data.intro_video,
          clients: clients,
          about_title: data.about_title,
          about_icons: eventIcons,
          whyChoose_title: data.whyChoose_title,
          whyChoose_description: data.whyChoose_description,
          whyChoose_events: wcEvents,
          whyChoose_cta_title: data.whyChoose_cta_title,
          whyChoose_cta_link: data.whyChoose_cta_link,
          events_title: data.events_title,
          events_description: data.events_description,
          events_cta_title: data.events_cta_title,
          events_cta_link: data.events_cta_link,
          social_news_title: data.social_news_title,
          social_news_description: data.social_news_description,
          news_cta_title: data.news_cta_title,
          news_cta_link: data.news_cta_link,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
          intro_button: data.intro_button,
          intro_button_link: data.intro_button_link,
          intro_image: image,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          setIsLoading(false);
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Home Page</h5>
              <hr />
              <form onSubmit={handleSubmit(createHomePage)}>
                <div className="mt-4">
                  <h5>Intro Section</h5>
                  <hr />
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label>
                          Heading(H1){" "}
                          <small
                            className="text-muted"
                            style={{ opacity: 0.5 }}
                          >
                            ({allFields?.intro_title?.length} / 68)
                          </small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("intro_title", { required: true })}
                          placeholder="Enter title"
                        />
                        {errors.intro_title && (
                          <span className="text-danger">Title is required</span>
                        )}
                      </div>
                      <div className="mb-3">
                        <label>
                          Description{" "}
                          <small
                            className="text-muted"
                            style={{ opacity: 0.5 }}
                          >
                            ({allFields?.intro_description?.length} / 175)
                          </small>
                        </label>
                        {/* intro_description */}
                        <textarea
                          className="form-control"
                          placeholder="Enter description"
                          {...register("intro_description", { required: true })}
                          style={{ minHeight: 125 }}
                        />
                        {errors.intro_description && (
                          <span className="text-danger">
                            Description is required
                          </span>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label>Intro section button text</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("intro_button", { required: true })}
                              placeholder="Enter button text"
                            />
                            {errors.intro_button && (
                              <span className="text-danger">
                                Intro section button text is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label>
                              Intro section button{" "}
                              <strong style={{ fontWeight: "bold !important" }}>
                                link
                              </strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("intro_button_link", {
                                required: true,
                              })}
                              placeholder="Enter button link"
                            />
                            {errors.intro_button_link && (
                              <span className="text-danger">
                                Intro section button link is required
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label>Right side image banner</label>
                        <div
                          className="dropzone p-4 mb-3"
                          style={{ minHeight: 120 }}
                        >
                          {!image ? (
                            <div
                              className="needsclick"
                              // {...getRootProps()}
                            >
                              {/* <input /> */}
                              <div className="mb-3">
                                <i className="ri-image-line display-4 text-muted"></i>
                              </div>
                              <h5 className="opacity-40">Right Side Image</h5>
                              <small className="text-muted mb-0 text-center">
                                <strong>(600X337)</strong>
                              </small>
                              <input
                                type="file"
                                className="image_upload_input"
                                onChange={(e) => handleLogoUpload(e)}
                              />
                            </div>
                          ) : (
                            <div className="filled_image">
                              <img
                                src={image}
                                alt="image"
                                className="img-fluid"
                              />
                              <div
                                className="remove_image"
                                onClick={() => setImage(null)}
                              >
                                <i className="mdi mdi-close-thick"></i>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="text-center" style={{ opacity: 0.7 }}>
                        <span>OR</span>
                      </div>
                      <div className="mb-3">
                        <label>Video (Right side video)</label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("intro_video", { required: false })}
                          placeholder="Enter video link"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <h5>Clients logo</h5>
                <hr />
                <div className="clients_wrapper">
                  <div className="row">
                    {clients.map((client, index) => {
                      return (
                        <div className="col-md-2" key={`client${index + 1}`}>
                          <div className="client_image_inner">
                            <span
                              className="closeIcon"
                              onClick={() => handleRemoveClient(index)}
                            >
                              <i className="ri-close-line"></i>
                            </span>
                            <img src={client} alt={`client${index + 1}`} />
                          </div>
                        </div>
                      );
                    })}
                    <div className="col-md-2">
                      <div className="add_client_btn">
                        <input
                          type="file"
                          className="upload_hidden"
                          onChange={(e) => uploadClientImage(e)}
                        />
                        <div>
                          <span className="icn">
                            <i className="ri-add-line"></i>
                          </span>
                          <h5 className="title">Add New Client</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h5 className="mt-3">Make Your Events section (red box)</h5>
                <div className="mb-3">
                  <label>
                    Box Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.about_title?.length} / 50)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("about_title", { required: true })}
                    placeholder="Enter title"
                  />
                  {errors.about_title && (
                    <span className="text-danger">Box Title is required</span>
                  )}
                </div>
                <div className="mb-3">
                  <label>Box icons</label>
                  {eventIcons.map((item, index) => {
                    return (
                      <div className="row event_icon_box mb-3 align-items-center">
                        <div className="col-md-2">
                          {item.image ? (
                            <div
                              className="client_image_inner"
                              style={{
                                backgroundColor: "#999999",
                                padding: 20,
                                borderRadius: 5,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img src={item.image} alt={item.title} />
                            </div>
                          ) : (
                            <div className="add_client_btn">
                              <input
                                type="file"
                                className="upload_hidden"
                                onChange={(e) => uploadIconImage(e, index)}
                              />
                              <div>
                                <span className="icn">
                                  <i className="ri-add-line"></i>
                                </span>
                                <h5 className="title">Add New Icon</h5>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-md-9">
                          <div className="row">
                            <div className="col-sm-6">
                              <input
                                type="text"
                                name="value"
                                value={item.value}
                                className="form-control mb-2"
                                onChange={(e) =>
                                  handleEventIconChange(e, index)
                                }
                                placeholder="enter value"
                              />
                              <input
                                type="text"
                                name="title"
                                value={item.title}
                                className="form-control"
                                onChange={(e) =>
                                  handleEventIconChange(e, index)
                                }
                                placeholder="enter title"
                              />
                            </div>
                            <div className="col-sm-6">
                              <textarea
                                type="text"
                                className="form-control"
                                name="description"
                                value={item.description}
                                placeholder="Enter description"
                                onChange={(e) =>
                                  handleEventIconChange(e, index)
                                }
                                style={{ resize: "none", minHeight: 85 }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <button
                            className="btn btn-danger btn-block"
                            style={{ width: "100%" }}
                            type="button"
                            onClick={() => deleteEventIcon(index)}
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="mb-3">
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={addEventIcon}
                    >
                      Add new icon box
                    </button>
                  </div>
                </div>
                <h5>Events section</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Events Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.events_title?.length} / 60)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("events_title", { required: true })}
                    placeholder="Enter title"
                  />
                  {errors.events_title && (
                    <span className="text-danger">
                      Events Title is required
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Events Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.events_description?.length} / 250)
                    </small>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    {...register("events_description", { required: true })}
                    placeholder="Enter description"
                  />
                  {errors.events_description && (
                    <span className="text-danger">
                      Events Description is required
                    </span>
                  )}
                </div>
                <h6>Events CTA</h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>CTA Title</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("events_cta_title", { required: true })}
                        placeholder="Enter title"
                      />
                      {errors.events_cta_title && (
                        <span className="text-danger">Title is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>CTA Link</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("events_cta_link", { required: true })}
                        placeholder="Enter title"
                      />
                      {errors.events_cta_link && (
                        <span className="text-danger">Link is required</span>
                      )}
                    </div>
                  </div>
                </div>

                <h5 className="mt-3">Why Choose Us section</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.whyChoose_title?.length} / 50)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("whyChoose_title", { required: true })}
                    placeholder="Enter title"
                  />
                  {errors.whyChoose_title && (
                    <span className="text-danger">Title is required</span>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.whyChoose_description?.length} / 250)
                    </small>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    {...register("whyChoose_description", { required: true })}
                    placeholder="Enter description"
                  />
                  {errors.whyChoose_description && (
                    <span className="text-danger">Description is required</span>
                  )}
                </div>
                <div className="mb-3">
                  <label>Why Choose Us Events</label>
                  {wcEvents.map((item, index) => {
                    return (
                      <div className="row mb-3" key={`wc${index}`}>
                        <div className="col-md-2">
                          {item.image ? (
                            <div className="client_image_inner">
                              <img
                                src={item.image}
                                alt={item.title}
                                style={{ width: "100%" }}
                              />
                            </div>
                          ) : (
                            <div className="add_client_btn">
                              <input
                                type="file"
                                className="upload_hidden"
                                onChange={(e) => uploadWhImage(e, index)}
                              />
                              <div>
                                <span className="icn">
                                  <i className="ri-add-line"></i>
                                </span>
                                <h5 className="title">Add New Image</h5>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-md-9">
                          <div className="row">
                            <div className="col-sm-12">
                              <input
                                type="text"
                                className="form-control mb-4"
                                placeholder="Enter title"
                                name="title"
                                value={item.title}
                                onChange={(e) => handleWcEventChange(e, index)}
                              />
                              <textarea
                                type="text"
                                className="form-control"
                                placeholder="Enter title"
                                name="description"
                                value={item.description}
                                onChange={(e) => handleWcEventChange(e, index)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <button
                            className="btn btn-danger"
                            type="button"
                            onClick={() => deleteWcEvent(index)}
                            style={{ width: "100%" }}
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                  <div className="d-flex justify-content-end mt-2">
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={() => addWcEvent()}
                    >
                      Add New Event
                    </button>
                  </div>
                </div>
                <h6>Section CTA</h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>CTA Title</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("whyChoose_cta_title", { required: true })}
                        placeholder="Enter title"
                      />
                      {errors.whyChoose_cta_title && (
                        <span className="text-danger">Title is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>CTA Link</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("whyChoose_cta_link", { required: true })}
                        placeholder="Enter title"
                      />
                      {errors.whyChoose_cta_link && (
                        <span className="text-danger">Link is required</span>
                      )}
                    </div>
                  </div>
                </div>
                <hr />
                <h5 className="mt-3">Social News Section</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.social_news_title?.length} / 50)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("social_news_title", { required: true })}
                    placeholder="Enter title"
                  />
                  {errors.social_news_title && (
                    <span className="text-danger">Title is required</span>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.social_news_description?.length} / 250)
                    </small>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    {...register("social_news_description", { required: true })}
                    placeholder="Enter Description"
                  />
                  {errors.social_news_description && (
                    <span className="text-danger">Description is required</span>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>Social News CTA Title</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("news_cta_title", { required: true })}
                        placeholder="Enter title"
                      />
                      {errors.news_cta_title && (
                        <span className="text-danger">Title is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>Social News CTA Link</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("news_cta_link", { required: true })}
                        placeholder="Enter link"
                      />
                      {errors.news_cta_link && (
                        <span className="text-danger">Link is required</span>
                      )}
                    </div>
                  </div>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default HomePage;
